export default __webpack_public_path__ + "static/media/search_white.3fbe0e13.svg";